<template>
<div class="chapter">
<div class="inner_page">
<p class="prect" id="contents"><a id="pVII"></a><i>Contents</i></p>
<p class="contents-"><a href="#/acknowledgments.htm#ack">Acknowledgments</a></p>
<p class="contents"><a href="#/introduction.htm#intro">Introduction</a></p>
<p class="contents-pt"><a href="#/part_01.htm#part1"><span class="fsc">PART ONE</span>. <span class="fsc">COLONIAL CLASHES</span></a></p>
<p class="contents-ct"><a href="#/chapter_01.htm#chap1">1. “Una Casa, Dos Mujeres”</a></p>
<p class="contents-ct"><a href="#/chapter_02.htm#chap2">2. “Poligamie/Nintiouiouesaïn”</a></p>
<p class="contents-ct"><a href="#/chapter_03.htm#chap3">3. “Christians Have Kept 3 Wives”</a></p>
<p class="contents-ct"><a href="#/chapter_04.htm#chap4">4. “Negroe Mens Wifes”</a></p>
<p class="contents-pt"><a href="#/part_02.htm#part2"><span class="fsc">PART TWO</span>. <span class="fsc">ENLIGHTENED ENCOUNTERS</span></a></p>
<p class="contents-ct"><a href="#/chapter_05.htm#chap5">5. “The Natural Violence of Our Passions”</a></p>
<p class="contents-ct"><a href="#/chapter_06.htm#chap6">6. “Such a Revolution as This”</a></p>
<p class="contents-ct"><a href="#/chapter_07.htm#chap7">7. “The Repugnance Inherent in Having Multiple Wives”</a></p>
<p class="contents-ct"><a href="#/chapter_08.htm#chap8">8. “Defence of Polygamy by a Lady”</a></p>
<p class="contents-ct1"><a href="#/conclusion.htm#conclu">Conclusion</a></p>
<p class="contents"><a href="#/notes.htm#notes">Notes</a></p>
<p class="contents"><a href="#/index.htm#index">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6142999d